<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
					<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'BattleReport'}" tag="li" class="breadcrumb-item">
					<a href="#">BattleReport</a>
					</router-link>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title">BattleReport</h3>
				<div class="row mb-3" >
					<div class="col-12">
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Stand',
	data() {
		return {
			"unit_data": {},
			"chara_identity": {}
		}
	},
	created: function() {
		var self = this;
		var actualUnits = this.$store.getters.getCharaIdentity;
		var units = self.$store.getters.getUnitData;
		var unit_data = new Array;
		_.forEach(units, function(value) {
			_.forEach(actualUnits, function(o) {
				if (o.unit_id == value.unit_id) {
					unit_data.push(value);
				}
			});
		});
		self.unit_data = _.orderBy(unit_data, ['search_area_width'], ['desc']);
	},
	computed: {
	},
	mounted: function() {
		var position = $(".chara-stand-box").position();
		$(".chara-stand-box").animate({			
			left: position.left + 1000
		}, 1000);
	}
}
</script>